import React, { Component, PropTypes } from 'react';
import { getTourney } from '../../util/EventUtil';
import TourneyLabel from '../TourneyLabel';

export default class EventTourneyCampLabel extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired
  };

  // TODO: this needs to be modified to handle camp events as well - ZP
  render() {
    const { event } = this.props;
    return <TourneyLabel tourney={getTourney(event) || {}}/>;
  }
}


// WEBPACK FOOTER //
// ./src/js/components/event/EventTourneyCampLabel.jsx